module.exports = __webpack_public_path__ + "img/782270022bbd723f6d3ddb520c7afa0b.png";